import React from 'react';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../hooks/useTags';
import GeneralModal from '../../../../components/UI/modal/GeneralModal';
import SendFormBtm from '../../../../components/buttons/SendFormBtm';
import Button from '../../../../components/buttons/Button';
import { useSelectSaveReqConfirmModalData } from '../../../../stores/saveReqConfirmModal.store';
import AlertUser from '../../../../components/Alerts/AlertUser';
import { IAlertState } from '../../../../interface/alert-state.interface';
import ConfirmationContent from './ConfirmationContent';
import ExistBtn from '../../../../components/buttons/ExistBtn';
import { ReceiptCutoff } from 'react-bootstrap-icons';
import { formatCurrencyNis } from '../../../../helpers/formating-currency';
import formLang from '../../../../data/lang/form.lang';
import styles from '../../../../pages/permit-request/style.module.scss';
import { useProjectConfigContext } from '../../../../contexts/ProjectConfigContext';
import { fromDecimalNCR } from '../../../../helpers/language';


const modalContentStyle: React.CSSProperties = { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' };

const SendReqConfirmModal = () => {

    const { projectConfigState } = useProjectConfigContext();
    const { handleSendPermitRequest, handleCloseConfirmModal, Formik } = usePermitRequestContext();
    const { isLoading, isModalOpen, modalMessage, step, savePermitProcessResult } = useSelectSaveReqConfirmModalData();
    const { hasReceipt, receiptUrl } = savePermitProcessResult;
    const { values } = Formik;

    const isInConfirmationStep = step === 'confirm';

    const userAlertState: IAlertState = {
        alertStatus: isLoading ? 'loading' : modalMessage ? 'hasAlert' : 'noAlert',
        message: modalMessage,
        alertColor: 'danger',
    };

    const payment = values.paymentAmount;
    const hasPayment = payment > 0 ? true : false;

    const generateTag = useTags();

    const modalTitlePreFinishStep = generateTag(addRequestPageLang, 'confirm-modal.title');
    const sendingFilesMsg = generateTag(addRequestPageLang, 'confirm-modal.sending-files-step');
    const submittingRequestMsg = generateTag(addRequestPageLang, 'confirm-modal.submitting-request-step');
    const modalContent = generateTag(addRequestPageLang, 'confirm-modal.message');
    const approvalBtnLabel = generateTag(addRequestPageLang, 'confirm-modal.approval');

    const modalTitleFinishStep = generateTag(addRequestPageLang, 'confirmation-receive-modal.title');

    const goBackFormBtnLabel = generateTag(addRequestPageLang, 'btns.back-to-form');
    const btnReceiptTag = generateTag(addRequestPageLang, 'btns.show-receipt');
    const goBackHomeBtnLabel = generateTag(addRequestPageLang, 'btns.back-to-home');

    const cancelBtnLabel = step === 'finished' ? goBackHomeBtnLabel : goBackFormBtnLabel;
    const modalTitle = step === 'finished' ? modalTitleFinishStep : modalTitlePreFinishStep;

    const modalSize = step === 'finished' ? 'M' : 'S';

    const f = 'רגע לפני שליחת הבקשה, אנא ודא שהפרטים נכונים';
    const fullName = 'פרטים אישיים';
    const carNumber = 'מספר רכב';
    const email = 'אימייל';
    const phoneNumber = 'מספר טלפון';
    const address = 'כתובת';
    const permitType = 'סוג תו';
    const permitCost = 'עלות תו';


    const streetCode = Number(values.contactDetails.streetId);

    const streetObj = projectConfigState.streets.find(street => {
        return street.id === streetCode;
    });

    const streetName = fromDecimalNCR(streetObj?.name ?? '');
    const addressValue = `${streetName ?? values.contactDetails.streetId}, ${values.contactDetails.house}`;
    const fullNameValue = `${values.personDetails.privateName} ${values.personDetails.familyName}, ${values.personDetails.id}`;

    const permitTypeLabel = generateTag(formLang, `permit-type-options.${values.permitType}`);

    return (
        <GeneralModal
            show={isModalOpen}
            title={modalTitle}
            loading={isLoading}
            alertUser={<AlertUser state={userAlertState} />}
            closingFunc={handleCloseConfirmModal}
            modalSize={modalSize}
            body={(
                <>
                    {step === 'confirm' && (
                        <div style={{ marginBottom: '1rem' }}>
                            <p className='mb-3 fs-4'>{f}</p>
                            <div className={styles.confirmationRowContainer}>
                                <div className={styles.confirmationRow}>
                                    <strong>{fullName}:</strong> {fullNameValue}
                                </div>
                                <div className={styles.confirmationRow}>
                                    <strong>{carNumber}:</strong> {values.carDetails.carId}
                                </div>
                                <div className={styles.confirmationRow}>
                                    <strong>{email}:</strong> {values.contactDetails.email}
                                </div>
                                <div className={styles.confirmationRow}>
                                    <strong>{phoneNumber}:</strong> {values.contactDetails.mobile}
                                </div>
                                <div className={styles.confirmationRow}>
                                    <strong>{address}:</strong> {addressValue}
                                </div>
                                <div className={styles.confirmationRow}>
                                    <strong>{permitType}:</strong> {permitTypeLabel}
                                </div>
                                {hasPayment && (
                                    <div className={styles.confirmationRow}>
                                        <strong>{permitCost}:</strong> {formatCurrencyNis(payment)}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className='fs-3' style={modalContentStyle}>
                        {step === 'uploading-files' && sendingFilesMsg}
                        {step === 'uploading-request' && submittingRequestMsg}
                    </div>
                    {step === 'finished' && <ConfirmationContent />}
                </>
            )}
            footer={(
                <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '0.5rem' }}>

                    {/* All Steps */}
                    <ExistBtn text={cancelBtnLabel} onClick={handleCloseConfirmModal} disabled={isLoading} />

                    {/* Pre Finish Step */}
                    <SendFormBtm show={isInConfirmationStep} btnLabel={approvalBtnLabel} onClick={handleSendPermitRequest} disabled={isLoading} />

                    {/* Finish Step */}
                    <Button show={hasReceipt} text={btnReceiptTag} endIcon={<ReceiptCutoff />} onClick={openReceipt} disabled={isLoading} />
                </div>
            )}
        />
    );

    function openReceipt() {
        window.open(receiptUrl, '_blank');
    }

}

export default SendReqConfirmModal;